// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2rdkm","inner":"Footer_inner__USSQf"};